import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import InventoryitemFilterCriteria from './InventoryitemFilterCriteria'
import InventoryitemList from './InventoryitemList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './InventoryitemAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setInventoryitemDashboardInventoryitemList } from '../../store/slice/ManufSlice';

export default function InventoryitemListView({setShowEdit,setInventoryitemId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.inventoryitemDashboard);   

    const [filteredInventoryitemList, setFilteredInventoryitemList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { inventoryitemDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (inventoryitemDashboard.inventoryitemList.length>-1){
        setFilteredInventoryitemList(inventoryitemDashboard.inventoryitemList);
        transformToCardFormat(inventoryitemDashboard.inventoryitemList, setCardList);
      }
    },[inventoryitemDashboard.inventoryitemList])

    useEffect(()=>{
          transformToCardFormat(filteredInventoryitemList, setCardList);
      },[filteredInventoryitemList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.creditcount==='' && filterCriteria.debitcount==='' && filterCriteria.balance==='' && filterCriteria.productid==='' && filterCriteria.productname==='' && filterCriteria.type==='' && filterCriteria.ops==='' && filterCriteria.orderid==='' && filterCriteria.partyname==='' ){
            setFilteredInventoryitemList(inventoryitemDashboard.inventoryitemList);
            transformToCardFormat(inventoryitemDashboard.inventoryitemList, setCardList);

        } else {
            setFilteredInventoryitemList(
                inventoryitemDashboard.inventoryitemList
                    .filter(inventoryitem=> inventoryitem.productname.toString().toUpperCase().includes(filterCriteria.productname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(inventoryitemDashboard.filteredInventoryitemList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <InventoryitemList
                    setShowEdit={setShowEdit}
                    setInventoryitemId = {setInventoryitemId}
                    tableList={filteredInventoryitemList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}